<template>
    <div>
        <slot name="link" v-bind="{downloadFiles}">
            <a target="_blank" class="button button-secondary" title="Alle Dateien herunterladen" v-interact="downloadFiles">
                <i class="material-icons md-18" aria-hidden="true" role="img">file_download</i>
                <span>Alle Dateien herunterladen</span>
            </a>
        </slot>

        <app-popup ref="popup" title="Alle Dateien herunterladen" title-icon="file_download" size="small" :buttons="buttons">
            <portuna-box class="portuna-box-disclaimer">
                <span class="font-weight-500">Hinweis</span>
                <div>Aufgrund der Überschreitung der Maximalgröße eines einzelnen Zip-Archivs, wurde dieses in mehrere Archive aufgeteilt.</div>
            </portuna-box>

            <div role="list">
                <div v-for="directory in directories" role="listitem">
                    <div class="download-tile file-card flex flex-vertical-middle flex-space-between">
                        <div class="flex flex-vertical-middle">
                            <div>
                                <i class="material-icons md-18 color-primary" aria-hidden="true" role="img">library_books</i>
                            </div>
                            <div>
                                <strong class="download-tile-name">{{directory.file}}.zip</strong>
                                <div><span class="gray">Dateigröße:</span> {{fileSize(directory.file_size)}}</div>
                            </div>
                        </div>

                        <a :href="downloadLink(directory)" :title="'Datei ' + directory.file + '.zip herunterladen'">
                            <div class="color-primary"><i class="material-icons md-18" aria-hidden="true" role="img">file_download</i> Herunterladen</div>
                        </a>
                    </div>
                </div>
            </div>
        </app-popup>
    </div>
</template>

<script setup lang="ts">
    import axios from 'axios';
    import AppPopup from '../components/AppPopup.vue';
    import fileSize from '../filters/fileSize';
    import Loader from '../library/intranet/loader';
    import {popupDefaultCloseButton} from '../library/popup';
    import TopMessageHandler from '../library/topMessageHandler';
    import {XHR_STATUS_DEFAULT} from '../utils/portuna';
    import PortunaBox from './PortunaBox.vue';
    import {ref, reactive} from 'vue';

    const props = defineProps<{
        createRoute: string;
        downloadRoute: string;
    }>();
    const popup         = ref<IAppPopupContext>();
    let directories     = reactive([]);
    let buttons         = reactive<PopupButton[]>([]);
    const downloadLink  = (directory: { file: string; zip: string }) =>
    {
        return (
            props.downloadRoute +
            (props.downloadRoute.substr(-1) === '/' ? '' : '/') +
            'file/' +
            btoa(directory.file) +
            '/zip/' +
            btoa(directory.zip)
        );
    };
    const downloadFiles = (): void =>
    {
        Loader.show('Das Zip-Archiv wird erstellt.');
        axios
        .get(props.createRoute)
        .then(({data: r}) =>
        {
            if (r.status === XHR_STATUS_DEFAULT)
            {
                if (!r.data.filesExist)
                {
                    TopMessageHandler.error('Die Dateien konnten nicht gefunden werden.');
                }
                else
                {
                    if (r.data.notExistingFiles.length >= 1)
                    {
                        let missingFiles = r.data.notExistingFiles.join(', ');
                        TopMessageHandler.info(
                            'Hinweis - folgende Dateien existieren nicht und konnten nicht gepackt werden: ' +
                            missingFiles,
                        );
                    }
                    if (parseInt(r.data.zipParts) === 1)
                    {
                        let a = document.createElement('a');
                        a.setAttribute('href', downloadLink(r.data.directories[0]));
                        a.setAttribute('download', 'download');
                        a.setAttribute('target', '_blank');
                        a.click();
                    }
                    else
                    {
                        directories = r.data.directories;
                        buttons     = [popupDefaultCloseButton];

                        popup.value?.open();
                    }
                }
            }
            else
            {
                throw r;
            }
        })
        .catch((error) =>
        {
            TopMessageHandler.error(error.message || 'Das Zip-Archiv konnte nicht geladen werden.');

            popup.value?.close();
        })
        .finally(() =>
        {
            Loader.hide();
        });
    };

</script>